import { render, staticRenderFns } from "./FolderInstance.vue?vue&type=template&id=621e9937&scoped=true"
import script from "./FolderInstance.vue?vue&type=script&lang=js"
export * from "./FolderInstance.vue?vue&type=script&lang=js"
import style0 from "./FolderInstance.vue?vue&type=style&index=0&id=621e9937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e9937",
  null
  
)

export default component.exports